/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of RolesClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfList_1OfKeyValuePair_2OfStringAndString,
  SuccessResponse_1OfList_1OfKeyValuePair_2OfInt32AndString,
  ModulePermission,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockRoles = [
  { key: 'StockCountRead', value: 'Stock Count Read' },
  { key: 'StockCountWrite', value: 'Stock Count Write' },
  { key: 'OrdersRead', value: 'Orders Read' },
  { key: 'OrdersWrite', value: 'Orders Write' },
  { key: 'InvoicesRead', value: 'Invoices Read' },
  { key: 'InvoicesWrite', value: 'Invoices Write' },
  { key: 'Admin', value: 'Administrator' },
  { key: 'UserManagement', value: 'User Management' },
];

const mockModulePermissions: ModulePermission[] = [
  {
    system: 'InventoryManagement',
    module: 'StockCount',
    permissions: ['StockCountRead', 'StockCountWrite', 'StockCountDelete'],
  },
  {
    system: 'InventoryManagement',
    module: 'Orders',
    permissions: ['OrdersRead', 'OrdersWrite', 'OrdersDelete', 'OrdersSubmit'],
  },
  {
    system: 'InventoryManagement',
    module: 'Invoices',
    permissions: ['InvoicesRead', 'InvoicesWrite', 'InvoicesProcess'],
  },
  {
    system: 'Administration',
    module: 'Users',
    permissions: ['UserManagement', 'RoleManagement'],
  },
];

const mockReminderRoles = [
  { key: 1, value: 'Store Manager' },
  { key: 2, value: 'Assistant Manager' },
  { key: 3, value: 'Stock Controller' },
];

/* ---- Mocked Client Implementation ---- */

import { IRolesClient } from '../../interfaces';
export class RolesClientMocked implements IRolesClient {
  constructor(baseUrl?: string) {}

  async rolesGET(cancelToken?: CancelToken): Promise<SuccessResponse_1OfList_1OfKeyValuePair_2OfStringAndString> {
    await delay();
    return successResponse(mockRoles) as SuccessResponse_1OfList_1OfKeyValuePair_2OfStringAndString;
  }

  async modulepermissions(cancelToken?: CancelToken): Promise<ModulePermission[]> {
    await delay();
    return mockModulePermissions;
  }

  async reminderroles(cancelToken?: CancelToken): Promise<SuccessResponse_1OfList_1OfKeyValuePair_2OfInt32AndString> {
    await delay();
    return successResponse(mockReminderRoles) as SuccessResponse_1OfList_1OfKeyValuePair_2OfInt32AndString;
  }
}
